import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { IonRow } from '@ionic/react';
import { RootState } from '../../models/RootState';
import withdrawal from '../../assets/images/common/icons/withdrawal.png';
import { Tabs, Tab, Button, TextField, Dialog } from '@material-ui/core';
import './Payment.scss';
import './Withdraw.scss';
import FEATURE_API from '../../api-services/feature-api';
import Spinner from '../../components/Spinner/Spinner';
import { toast } from 'react-toastify';
import SuccessIcon from '@material-ui/icons/CheckCircleOutline';
import ErrorIcon from '@material-ui/icons/ErrorOutline';
import { setOpenWithdrawModal } from '../../store';
import { AccountDetails } from './AccountDetails';
import { useHistory } from 'react-router';
import AGPAY_API from '../../api-services/feature-api';
import AbcMoney from './WithdrawalTabPanels/AbcMoney';
import Pgman from './WithdrawalTabPanels/Pgman';
import XenonPay from './WithdrawalTabPanels/XenonPay';
import { AvailablePaymentGateways } from '../../util/stringUtil';
import { PaymentMethodsInfo } from './Deposit.types';
import { fetchPaymentMethod } from './WithdrawalTabPanels/common';

type StoreProps = {
  setOpenWithdrawModal: Function;
};

const Withdrawal: React.FC<StoreProps> = (props) => {
  const { setOpenWithdrawModal } = props;
  const [tabValue, setTabValue] = useState<number>(0);
  const [showBankOptions, setShowBankOptions] = useState<boolean>(false);
  const [paymentOption, setPaymentOption] = useState<string>('NEFT');
  const [UpiOption, setUpiOption] = useState<string>('');
  const [onlinePaymentOption, setOnlinePaymentOption] = useState<string>('');
  const [accountDetails, setAccountDetails] = useState<AccountDetails[]>();
  const [selectedAccountId, setSelectedAccountId] = useState<string>();
  const [loading, setLoading] = useState<boolean>(false);
  const [addAccount, setAddAccount] = useState<boolean>(false);
  const [accountNumber, setAccountNumber] = useState<string>();
  const [withdrawAmount, setWithdrawAmount] = useState<string>();
  const [holderName, setHolderName] = useState<string>();
  const [displayName, setDisplayName] = useState<string>();
  const [ifscCode, setIfscCode] = useState<string>();
  const [bankName, setBankName] = useState<string>();
  const [branchName, setBranchName] = useState<string>();
  const [phoneNumber, setPhoneNumber] = useState<string>();
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [deleteId, setDeleteId] = useState<number>();
  const [providersList, setProvidersList] = useState([]);
  const [paymentMethodsInfo, setPaymentMethodsInfo] =
    useState<PaymentMethodsInfo>({});
  const [paymentGatewaysCount, setPaymentGatewaysCount] = useState<number>(0);
  let count = 0;
  const history = useHistory();

  const [withdrawNotes, setWithdrawNotes] = useState<string>();

  const getPaymentProviders = async () => {
    setLoading(true);
    const accountId = sessionStorage.getItem('aid');
    try {
      const response = await AGPAY_API.get(
        `/agpay/v2/payment-settings/accounts/${accountId}`,
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
            'Content-Type': 'application/json',
          },
        }
      );
      if (response.status === 200) {
        setPaymentMethodsInfo(response?.data?.withdraw_payment_methods);
        const prList = response?.data?.withdraw_provider_list;
        let gatewaysCount = 0;
        prList.map((paymentGateway) => {
          if (paymentGateway !== AvailablePaymentGateways.PGMAN)
            gatewaysCount++;
        });
        setPaymentGatewaysCount(gatewaysCount);
        setProvidersList(prList);
      }
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };

  useEffect(() => {
    setPaymentGatewaysCount(0);
    getPaymentProviders();
  }, []);

  const submitOnlinePayment = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        amount: Number(withdrawAmount),
        gatewayProvider: 'INSTAPETECH',
        notes: withdrawNotes,
        payment_method_id: selectedAccountId,
        payment_option: onlinePaymentOption,
        // paymentMethod: accountDetails[0].paymentMethod,
      };
      setLoading(true);
      const response = await FEATURE_API.post(
        `/agpay/v1/online/:payout`,
        payload,
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
        }
      );
      if (response.status === 204) {
        toast.success(
          <div>
            <SuccessIcon /> {'Transaction Saved Successfully!'}
          </div>,
          {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
      } else {
        toast.error(
          <div>
            <ErrorIcon /> {'Something went wrong'}
          </div>,
          {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
      }
      setLoading(false);
    } catch (error) {
      toast.error(
        <div>
          <ErrorIcon /> {error?.response?.data?.message}
        </div>,
        {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );

      setLoading(false);
    }
  };

  const submitPayment = async (e) => {
    e.preventDefault();
    if (Number(withdrawAmount) < 100) {
      toast.error(
        <div>
          <ErrorIcon /> {'Withdrawal Amount cannot be less than 100'}
        </div>,
        {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
      return false;
    }
    setLoading(true);
    try {
      const payload = {
        amount: withdrawAmount,
        notes: withdrawNotes,
        payment_method_id: selectedAccountId,
        // paymentMethod: accountDetails[0].paymentMethod,
      };
      const response = await FEATURE_API.post(
        `/agpay/v2/pgman/transactions/:withdraw`,
        payload,
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
        }
      );
      if (response.status === 204) {
        toast.success(
          <div>
            <SuccessIcon /> {'Transaction Saved Successfully!'}
          </div>,
          {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
        setOpenWithdrawModal(false);
        history.push('/my_transactions');
      } else {
        toast.error(
          <div>
            <ErrorIcon /> {'Something went wrong'}
          </div>,
          {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
      }
      setLoading(false);
    } catch (error) {
      toast.error(
        <div>
          <ErrorIcon /> {error?.response?.data?.message}
        </div>,
        {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );

      setLoading(false);
    }
  };

  const submitXenonPay = async (e) => {
    e.preventDefault();
    if (Number(withdrawAmount) < 100) {
      toast.error(
        <div>
          <ErrorIcon /> {'Withdrawal Amount cannot be less than 100'}
        </div>,
        {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
      return false;
    }
    setLoading(true);
    try {
      const payload = {
        amount: withdrawAmount,
        notes: withdrawNotes,
        payment_method_id: selectedAccountId,
      };
      const response = await FEATURE_API.post(
        `/agpay/v2/xenon-pay/transactions/:withdraw`,
        payload,
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
        }
      );
      if (response.status === 204) {
        toast.success(
          <div>
            <SuccessIcon /> {'Transaction Saved Successfully!'}
          </div>,
          {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
        setOpenWithdrawModal(false);
        history.push('/my_transactions');
      } else {
        toast.error(
          <div>
            <ErrorIcon /> {'Something went wrong'}
          </div>,
          {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
      }
      setLoading(false);
    } catch (error) {
      toast.error(
        <div>
          <ErrorIcon /> {error?.response?.data?.message}
        </div>,
        {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );

      setLoading(false);
    }
  };

  useEffect(() => {
    if (paymentOption) {
      fetchPaymentMethod(paymentOption, setAccountDetails);
      setAccountDetails([]);
      setSelectedAccountId('');
      setWithdrawAmount('');
      setWithdrawNotes('');
      setAccountNumber('');
      setWithdrawAmount('');
      setHolderName('');
      setDisplayName('');
      setIfscCode('');
      setAddAccount(false);
    }
  }, [paymentOption]);

  useEffect(() => {
    if (addAccount) {
      setSelectedAccountId('');
    }
  }, [addAccount]);

  useEffect(() => {
    if (selectedAccountId) {
      setAddAccount(false);
    }
  }, [selectedAccountId]);

  const submitDetails = async (e) => {
    e.preventDefault();
    console.log(e);
    setLoading(true);
    try {
      const payload = {
        accountHolderName: holderName,
        accountNumber: accountNumber,
        displayName: '',
        bankName: bankName,
        branchName: branchName,
        ifscCode: ifscCode,
        paymentMethod:
          paymentOption === 'NEFT' ? 'BANK_TRANSFER' : 'UPI_TRANSFER',
      };

      const payTMPayload = {
        accountNumber: accountNumber,
        accountHolderName: holderName,
        displayName: displayName,
        paymentMethod: 'PAYTM_WALLET_TRANSFER',
      };
      const response = await FEATURE_API.post(
        `/agpay/v2/pgman/payment-methods`,
        paymentOption === 'PAYTM_WALLET' ? payTMPayload : payload,
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
        }
      );
      if (response.status === 200 || 204) {
        toast.success(
          <div>
            <SuccessIcon /> {'Deatils Saved Successfully!'}
          </div>,
          {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
        history.push('/my_transactions');
        setOpenWithdrawModal(false);
      } else {
        toast.error(
          <div>
            <ErrorIcon /> {'Something went wrong'}
          </div>,
          {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
      }
      setLoading(false);
    } catch (error) {
      toast.error(
        <div>
          <ErrorIcon /> {error?.response?.data?.message}
        </div>,
        {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );

      setLoading(false);
    }
  };

  const submitXenonPayPaymentDetails = async (e) => {
    e.preventDefault();
    console.log(e);
    setLoading(true);
    try {
      const payload = {
        accountHolderName: holderName,
        accountNumber: accountNumber,
        ifscCode: ifscCode,
        bankName: bankName,
        branchName: branchName,
        phoneNumber: phoneNumber,
        email: 'bjhb@nk.nk',
        upiId: '',
      };

      const response = await FEATURE_API.post(
        `/agpay/v2/xenon-pay/payment-methods`,
        payload,
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
        }
      );
      if (response.status === 200 || 204) {
        toast.success(
          <div>
            <SuccessIcon /> {'Deatils Saved Successfully!'}
          </div>,
          {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
        history.push('/my_transactions');
        setOpenWithdrawModal(false);
      } else {
        toast.error(
          <div>
            <ErrorIcon /> {'Something went wrong'}
          </div>,
          {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
      }
      setLoading(false);
    } catch (error) {
      toast.error(
        <div>
          <ErrorIcon /> {error?.response?.data?.message}
        </div>,
        {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );

      setLoading(false);
    }
  };

  const deletePaymentMethod = async () => {
    try {
      const response = await AGPAY_API.delete(
        `/agpay/v2/pgman/payment-methods/${deleteId}`,
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
        }
      );

      if (response.status === 204 || 200) {
        fetchPaymentMethod(paymentOption, setAccountDetails);
        toast.success(
          <div>
            <SuccessIcon /> {'Beneficiary account deleted successfully'}
          </div>
        );
      }
      // setDeleteId(null);
    } catch (err) {
      toast.error(err.response.data.message);
      // setDeleteId(null);
    }
  };

  const renderWithdrawForm = (
    paymentGateway: AvailablePaymentGateways,
    index: number,
    tabValue: number
  ) => {
    switch (paymentGateway) {
      case AvailablePaymentGateways.ABCMONEY:
        return (
          <AbcMoney
            index={index}
            accountDetails={accountDetails}
            paymentMethodsInfo={paymentMethodsInfo}
            paymentOption={paymentOption}
            setPaymentOption={setPaymentOption}
            tabValue={tabValue}
            selectedAccountId={selectedAccountId}
            setSelectedAccountId={setSelectedAccountId}
            setShowDeleteModal={setShowDeleteModal}
            onlinePaymentOption={onlinePaymentOption}
            setAddAccount={setAddAccount}
            setDeleteId={setDeleteId}
            setOnlinePaymentOption={setOnlinePaymentOption}
            submitOnlinePayment={submitOnlinePayment}
            submitPayment={submitPayment}
            setWithdrawAmount={setWithdrawAmount}
            withdrawAmount={withdrawAmount}
            loading={loading}
            setWithdrawNotes={setWithdrawNotes}
            withdrawNotes={withdrawNotes}
            setAccountDetails={setAccountDetails}
          />
        );

      case AvailablePaymentGateways.PGMAN:
        return (
          <Pgman
            index={index}
            paymentOption={paymentOption}
            paymentMethodsInfo={paymentMethodsInfo}
            setPaymentOption={setPaymentOption}
            setUpiOption={setUpiOption}
            tabValue={tabValue}
            UpiOption={UpiOption}
            accountDetails={accountDetails}
            selectedAccountId={selectedAccountId}
            setDeleteId={setDeleteId}
            setSelectedAccountId={setSelectedAccountId}
            setShowDeleteModal={setShowDeleteModal}
            loading={loading}
            setAddAccount={setAddAccount}
            setWithdrawAmount={setWithdrawAmount}
            setWithdrawNotes={setWithdrawNotes}
            submitOnlinePayment={submitOnlinePayment}
            submitPayment={submitPayment}
            withdrawAmount={withdrawAmount}
            withdrawNotes={withdrawNotes}
            addAccount={addAccount}
            accountNumber={accountNumber}
            setAccountNumber={setAccountNumber}
            submitDetails={submitDetails}
            bankName={bankName}
            branchName={branchName}
            holderName={holderName}
            ifscCode={ifscCode}
            setBankName={setBankName}
            setBranchName={setBranchName}
            setHolderName={setHolderName}
            setIfscCode={setIfscCode}
            displayName={displayName}
            setDisplayName={setDisplayName}
            setAccountDetails={setAccountDetails}
          />
        );

      case AvailablePaymentGateways.XENONPAY:
        return (
          <XenonPay
            index={index}
            paymentMethodsInfo={paymentMethodsInfo}
            paymentOption={paymentOption}
            setPaymentOption={setPaymentOption}
            tabValue={tabValue}
            accountDetails={accountDetails}
            selectedAccountId={selectedAccountId}
            setDeleteId={setDeleteId}
            setSelectedAccountId={setSelectedAccountId}
            setShowDeleteModal={setShowDeleteModal}
            loading={loading}
            setAddAccount={setAddAccount}
            setWithdrawAmount={setWithdrawAmount}
            setWithdrawNotes={setWithdrawNotes}
            withdrawAmount={withdrawAmount}
            withdrawNotes={withdrawNotes}
            addAccount={addAccount}
            accountNumber={accountNumber}
            setAccountNumber={setAccountNumber}
            branchName={branchName}
            holderName={holderName}
            ifscCode={ifscCode}
            setBranchName={setBranchName}
            setHolderName={setHolderName}
            setIfscCode={setIfscCode}
            phoneNumber={phoneNumber}
            setPhoneNumber={setPhoneNumber}
            submitXenonPay={submitXenonPay}
            submitXenonPayPaymentDetails={submitXenonPayPaymentDetails}
            setAccountDetails={setAccountDetails}
          />
        );

      default:
        return null;
    }
  };

  return (
    <div className="reports-ctn payment-withdraw-ctn">
      {loading ? <Spinner /> : null}
      {/* {
        providersList?.length === 0 ? (
          <Redirect to="/home" />
        ) : null
      } */}
      <div className="header-ctn my-payment-option">
        <IonRow>
          <div className="img-page-title-row mob-view">
            <img className="title-image" src={withdrawal} />
            <div className="title">Withdraw</div>
          </div>
          <div className="mob-view">
            <Button
              onClick={(e) => {
                history.push('/transaction/deposit');
              }}
              className="withdraw-deposit-btn actions-btn mob-view"
            >
              Deposit
            </Button>
          </div>
        </IonRow>
        <div className="deposit-form-ctn">
          {providersList?.length > 1 && (
            <Tabs
              value={tabValue}
              onChange={(_, newValue) => {
                setTabValue(newValue);
              }}
            >
              {providersList.map((paymentGateway, index) => (
                <Tab
                  value={index}
                  label={
                    paymentGateway === AvailablePaymentGateways.PGMAN
                      ? 'Manual'
                      : `Auto ${paymentGatewaysCount > 1 ? ++count : ''}`
                  }
                />
              ))}
            </Tabs>
          )}

          {providersList?.length > 0 &&
            providersList.map((provider, index) =>
              renderWithdrawForm(provider, index, tabValue)
            )}
        </div>
      </div>

      <Dialog
        open={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        className="payment-method-confirm"
      >
        <div className="dialog-content">
          {/* <div className="void-bet-text">{getDisplayName(betText)}</div> */}
          <div className="payment-text-bold">This account will be deleted!</div>
          <div>Confirm your action to delete this account</div>
        </div>
        <div className="dialog-footer">
          <Button
            color="primary"
            className="footer-action-btn"
            onClick={() => {
              deletePaymentMethod();
              setShowDeleteModal(false);
            }}
          >
            Yes, Confirm
          </Button>
          <Button
            color="primary"
            className="footer-action-btn"
            onClick={() => {
              setShowDeleteModal(false);
              setDeleteId(null);
            }}
          >
            Cancel
          </Button>
        </div>
      </Dialog>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {};
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    setOpenWithdrawModal: (val) => dispatch(setOpenWithdrawModal(val)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Withdrawal);
